/**
 * Klaviyo Handler
 * Versteckt Klaviyo Popup via CSS wenn Cart-Drawer offen ist
 */

(function() {
  'use strict';
  
  var cartDrawer = document.querySelector('cart-drawer');
  var styleId = 'klaviyo-cart-blocker';
  
  if (!cartDrawer) return;
  
  function injectBlockerCSS() {
    if (document.getElementById(styleId)) return;
    
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      div[aria-label="POPUP Form"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }
    `;
    
    document.head.appendChild(style);
  }
  
  function removeBlockerCSS() {
    var style = document.getElementById(styleId);
    if (style) style.remove();
  }
  
  var observer = new MutationObserver(function() {
    if (cartDrawer.hasAttribute('open')) {
      injectBlockerCSS();
    } else {
      removeBlockerCSS();
    }
  });
  
  observer.observe(cartDrawer, { 
    attributes: true, 
    attributeFilter: ['open'] 
  });
  
  if (cartDrawer.hasAttribute('open')) {
    injectBlockerCSS();
  }
  
})();
